import { useIntl } from "react-intl";

import dynamic from "next/dynamic";

import SEO from "../../components/SEO";
import Header from "../../components/Header";
import Slider from "../../components/Slider";
import Breadcrumbs from "../../components/Breadcrumbs";
import Footer from "../../components/Footer";
import CookieAccept from "../../components/CookieAccept";

import Section from "../../components/Section";
import Panel from "../../components/Panel";
import DeclarationBox from "../../components/DeclarationBox";
import DeclarationBoxItem from "../../components/DeclarationBoxItem";
import Tabs from "../../components/Tabs";
import AnotherCity from "../../components/AnotherCity";
import BackButton from "../../components/BackButton";
import DeclarationModal from "../../components/DeclarationModal";

import Variables from "../../variables/variables.json";

// PODATEK OD ŚRODKÓW TRANSPORTOWYCH
import TransportoweSection1PL from "../../content/witryna/podatek-od-srodkow-transportowych/section-1_pl.mdx";
import TransportoweSection2PL from "../../content/witryna/podatek-od-srodkow-transportowych/section-2_pl.mdx";

// PODATEK OD NIERUCHOMOŚCI
import NieruchomosciSection1PL from "../../content/witryna/podatek-od-nieruchomosci/section-1_pl.mdx";
import NieruchomosciSection2PL from "../../content/witryna/podatek-od-nieruchomosci/section-2_pl.mdx";

// PODATEK ROLNY
import RolnySection1PL from "../../content/witryna/podatek-rolny/section-1_pl.mdx";
import RolnySection2PL from "../../content/witryna/podatek-rolny/section-2_pl.mdx";

// PODATEK LEŚNY
import LesnySection1PL from "../../content/witryna/podatek-lesny/section-1_pl.mdx";
import LesnySection2PL from "../../content/witryna/podatek-lesny/section-2_pl.mdx";

// OPŁATA ZA GOSPODAROWANIE ODPADAMI KOMUNALNYMI
import OdpadykomunalneSection1PL from "../../content/witryna/odpadykomunalne/section-1_pl.mdx";
import OdpadykomunalneSection2PL from "../../content/witryna/odpadykomunalne/section-2_pl.mdx";

export default function WitrynaLayout(props) {
	const intl = useIntl();

	let Miasto = props.miasto;
	let Podatek = props.podatek;

	// TRANSPORTOWE
	const CityTransportoweSection1PL = dynamic(() =>
		import(
			"../../content/" +
				Variables.miasta[Miasto].name.url +
				"/podatek-od-srodkow-transportowych/section-1_pl.mdx"
		),
	);

	const CityTransportoweSection2PL = dynamic(() =>
		import(
			"../../content/" +
				Variables.miasta[Miasto].name.url +
				"/podatek-od-srodkow-transportowych/section-2_pl.mdx"
		),
	);

	// NIERUCHOMOSCI
	const CityNieruchomosciSection1PL = dynamic(() =>
		import(
			"../../content/" +
				Variables.miasta[Miasto].name.url +
				"/podatek-od-nieruchomosci/section-1_pl.mdx"
		),
	);

	const CityNieruchomosciSection2PL = dynamic(() =>
		import(
			"../../content/" +
				Variables.miasta[Miasto].name.url +
				"/podatek-od-nieruchomosci/section-2_pl.mdx"
		),
	);

	// ROLNY
	const CityRolnySection1PL = dynamic(() =>
		import(
			"../../content/" + Variables.miasta[Miasto].name.url + "/podatek-rolny/section-1_pl.mdx"
		),
	);

	const CityRolnySection2PL = dynamic(() =>
		import(
			"../../content/" + Variables.miasta[Miasto].name.url + "/podatek-rolny/section-2_pl.mdx"
		),
	);

	// LESNY
	const CityLesnySection1PL = dynamic(() =>
		import(
			"../../content/" + Variables.miasta[Miasto].name.url + "/podatek-lesny/section-1_pl.mdx"
		),
	);

	const CityLesnySection2PL = dynamic(() =>
		import(
			"../../content/" + Variables.miasta[Miasto].name.url + "/podatek-lesny/section-2_pl.mdx"
		),
	);

	// ODPADY KOMUNALNE
	const CityOdpadyKomunalneSection1PL = dynamic(() =>
		import(
			"../../content/" +
				Variables.miasta[Miasto].name.url +
				"/oplata-za-gospodarowanie-odpadami-komunalnymi/section-1_pl.mdx"
		),
	);

	const CityOdpadyKomunalneSection2PL = dynamic(() =>
		import(
			"../../content/" +
				Variables.miasta[Miasto].name.url +
				"/oplata-za-gospodarowanie-odpadami-komunalnymi/section-2_pl.mdx"
		),
	);

	return (
		<>
			{/* HEAD */}
			<SEO miasto={Miasto} podatek={Podatek} />

			{/* TOP */}
			<Header miasto={Miasto} />

			<Slider miasto={Miasto} podatek={Podatek} typeHero="slider" />

			<Breadcrumbs miasto={Miasto} layout="dark" />

			{/* SECTION */}
			<Section lightdark mdx>
				{Podatek == "transportowe" && <TransportoweSection1PL />}
				{Podatek == "nieruchomosci" && <NieruchomosciSection1PL />}
				{Podatek == "rolny" && <RolnySection1PL />}
				{Podatek == "lesny" && <LesnySection1PL />}
				{Podatek == "odpadykomunalne" && <OdpadykomunalneSection1PL />}
			</Section>

			<Section id="wypelnij-deklaracje" title="sections.wypelnijdeklaracje.title">
				<DeclarationBox center>
					<DeclarationBoxItem
						miasto={Miasto}
						podatek={Podatek}
						noReadMore
						soon={Variables.miasta[Miasto].podatkiSoon[Podatek].soon && true}
					/>
				</DeclarationBox>
			</Section>

			{Variables.miasta[Miasto].documentsAvailable[Podatek] && (
				<Section
					lightdark
					smallTop
					title={"miasta." + Miasto + ".documents.podatki." + Podatek + ".title"}
				>
					<Tabs miasto={Miasto} podatek={Podatek} />
				</Section>
			)}

			<Section title={"miasta." + Miasto + ".sections.pozostalepodatki.title"}>
				<DeclarationBox miasto={Miasto} center>
					{Variables.miasta[Miasto].declarationBoxItem[Podatek].map((declarationBoxItem, index) => {
						return (
							<DeclarationBoxItem
								miasto={Miasto}
								podatek={declarationBoxItem.title}
								key={index}
								soon={declarationBoxItem.soon && true}
							/>
						);
					})}
				</DeclarationBox>
				<DeclarationModal miasto={Miasto} />
			</Section>

			<Section id="czytaj-wiecej" lightdark mdx>
				{Podatek == "transportowe" && <TransportoweSection2PL />}
				{Podatek == "nieruchomosci" && <NieruchomosciSection2PL />}
				{Podatek == "rolny" && <RolnySection2PL />}
				{Podatek == "lesny" && <LesnySection2PL />}
				{Podatek == "odpadykomunalne" && <OdpadykomunalneSection2PL />}
			</Section>

			<Section large>
				<Panel title="sections.anothercity.title" center>
					<AnotherCity />
				</Panel>
			</Section>

			<Section>
				<BackButton />
			</Section>

			{/* BOTTOM */}
			<Footer miasto={Miasto} />
		</>
	);
}
